import { UserModel } from "@/model/user/userModel";

export function ConvertToUserModel(userInfo: any): UserModel {
  /* eslint-disable @typescript-eslint/camelcase */
  const userModel: UserModel = {
    userId: userInfo.id,
    displayName: userInfo.given_name,
    lastLogInDateTime: userInfo.lastLogInDateTime,
    registerDateTime: userInfo.registerDateTime,
    phone: userInfo.phone_number,
    pictureUrl: userInfo.picture,
    signatureUrl: userInfo.signatureUrl,
    userEmail: userInfo.userEmail,
    position: userInfo.positionId,
    accountingFirm: userInfo.accountingFirmId,
  };

  return userModel;
}

export function ConvertToUserDetailList(userDetailRawList: any) {
  let userDetailList = [];
  if (userDetailRawList && userDetailRawList.length > 0) {
    for (let userDetailRaw of userDetailRawList) {
      userDetailList.push({
        userId: userDetailRaw.userId,
        userEmail: userDetailRaw.userEmail,
        userType: userDetailRaw.userType,
        signatureUrl: userDetailRaw.signatureUrl,
        displayName: userDetailRaw.displayName,
        accountingFirmId: userDetailRaw.accountingFirmId,
        phone: userDetailRaw.phone,
        pictureUrl: userDetailRaw.pictureUrl,
        userName: userDetailRaw.userName,
        firstName: userDetailRaw.firstName,
        lastName: userDetailRaw.lastName,
      });
    }
  }
  return userDetailList;
}
